import { render, staticRenderFns } from "./DingdinggroupList.vue?vue&type=template&id=122dbc1f&scoped=true"
import script from "./DingdinggroupList.vue?vue&type=script&lang=js"
export * from "./DingdinggroupList.vue?vue&type=script&lang=js"
import style0 from "./DingdinggroupList.vue?vue&type=style&index=0&id=122dbc1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122dbc1f",
  null
  
)

export default component.exports